/**
 * @packageDocumentation
 * @module Misc
 * @category Core
 */
import { InjectionToken, Provider } from '@angular/core';

export const APP_VERSION = new InjectionToken<string | null>('App Version');

/**
 * Регистрация версии CRM, который будет передаваться в запросах {@link API.authDeviceInterceptor}
 *
 * @group Providers
 *
 * @param version
 * @returns
 */
export function provideAppVersion(version?: string | null): Provider {
  return {
    provide: APP_VERSION,
    useValue: version || null,
  };
}
